import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
function Home() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  // const showToast = () => {
  // 	// toast({
  // 	// 	title: "Button Clicked",
  // 	// 	description: "You have clicked the button",
  // 	// 	status: "info",
  // 	// 	duration: 5000,
  // 	// 	isClosable: true,
  // 	// 	position: "bottom-right",
  // 	// });
  // }

  useEffect(() => {
    navigate("/login");
  }, []);
  return <div>{t("Welcome!")}</div>;
}
export default Home;
